export const PatientInactivationTypeEnum = {
  accessRevoked: "ACCESS_REVOKED",
  rateLimit: "RATE_LIMIT",
} as const;

export const PatientStatusEnum = {
  active: "ACTIVE",
  active90Day: "ACTIVE 90-DAY",
  assessment: "ASSESSMENT",
  extendedCare: "EXTENDED CARE",
  inactive: "INACTIVE",
  referred: "REFERRED",
  registered: "REGISTERED",
} as const;
